import { render, staticRenderFns } from "./MyCertificatesView.vue?vue&type=template&id=62baca80&scoped=true&"
import script from "./MyCertificatesView.vue?vue&type=script&lang=ts&"
export * from "./MyCertificatesView.vue?vue&type=script&lang=ts&"
import style0 from "./MyCertificatesView.vue?vue&type=style&index=0&id=62baca80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62baca80",
  null
  
)

export default component.exports